/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    data: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    getLoginBanData({ commit, rootState }, params) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.get(`/games/${gameCode}/login-blacklists`,params, (res) => {
            return true;
        })
    },
    createdLoginBan({ commit, rootState }, params) {
        return rootState.$helper.request.post('/games/{game_code}/login-blacklist/new', params)
    },
    editLoginBan({ commit, rootState }, params) {
        return rootState.$helper.request.put(`/games/{game_code}/login-blacklist/edit`, params, (res) => {
            return true;
        })
    },
    deleteLoginBan({ commit, rootState }, params) {
        return rootState.$helper.request.delete(`/games/{game_code}/login-blacklist/delete`, params, (res) => {
            return true;
        })
    },
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {

};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    changeData(state, data) {
        state.data = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/riskManagement/loginBan.js